import React from 'react';
import useServicesPerYearDonutChart from './hooks/useServicesPerYearDonutChart';
import { Donut } from '../../../Common/Charts/Donut';

export const ServicesPerYearDonut = ({ heigth = 300 }) => {
    const { series, subtitles } = useServicesPerYearDonutChart();


    return (
        <Donut
            title={`Tipo de Financiamento Federal`}
            series={series}
            subtitles={subtitles}
            chartData={[]}
            isMoney
        />
    );
};
